import React, { Fragment, useContext, useEffect, useState } from 'react';
import PageHeading from '../../Components/PageHeading/PageHeading';
import Swal from 'sweetalert2';


import img from './toy_sample.png';
import { UserAuthContext } from '../../Contexts/UserAuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";
import axios from 'axios';
import { IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import SamplePdfModal from "../../Components/SamplePdfModal/SamplePdfModal";
import ContentToy from "../Gallery/ContentToy";
import AiContentAudit from '../../Components/AiContentAudit/AiContentAudit';
import AiFactsDisplay from '../../Components/AiFacts/AiFactsDisplay';
import CreditsButton from '../../utils/CreditsButton';


const TestDigitalToy = () => {
    const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
    const [name, setName] = useState('');
    const [occupation, setOccupation] = useState('');
    const [prompt, setPrompt] = useState('');
    const [image, setImage] = useState([]);
    const [loading, setLoading] = useState(false);
    const [resultImage, setResultImage] = useState(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [auditChecked, setAuditChecked] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    // const handleSubmitCredits = async (e) => {
    //     const deductedCredits = AIuser.credits - 10;

    //     await axios
    //         .put(
    //             "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
    //             { email: AIuser?.email, credits: deductedCredits },
    //             {
    //                 headers: {
    //                     authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
    //                 },
    //             }
    //         )
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setUserRefetch(!userRefetch);
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };



    const handleGenerate = async () => {

        if (AIuser?.credits < 10) {
            Swal.fire({
                text: "You don't have enough credits! Please buy credits to continue.",
                icon: "error",
                confirmButtonText: "Buy",
                background: '#011225',
                color: '#fff',
            }).then((value) => {
                if (value) {
                    navigate("/purchase");
                }
            });
        }
        else {
            if (image.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Please upload an image.',
                    background: '#011225',
                    color: '#fff',
                });
                return;
            }

            const randomChars =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567891011121314156655";
            let transactionId = "";
            for (let i = 0; i < 8; i++) {
                transactionId += randomChars.charAt(
                    Math.floor(Math.random() * randomChars.length)
                );
            }
            const formData = new FormData();
            formData.append('name', name);
            formData.append('occupation', occupation);
            formData.append('prompt', prompt);
            image.forEach((img) => formData.append('uploads', img));

            setLoading(true);
            setResultImage(null);

            try {
                const response = await fetch('https://backend.whalesai.com/api/v1/chatgpt/test/image/conversion', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        authorization: `Bearer ${localStorage.getItem('aiUser')}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    // handleSubmitCredits();
                    setUserRefetch(!userRefetch)
                    setResultImage(data.imageUrl);

                    await axios.post(
                        "https://backend.whalesai.com/api/v1/credits-transaction/create",
                        {
                            aiType: "Toy Stories Ai",
                            transactionId: transactionId,
                            requestQues: `Name: ${name}, Profession: ${occupation}`,
                            response: data.imageUrl,
                            credit: 10,
                            userId: AIuser?._id,
                            // textwithHashTag: res?.data?.textwithHashTag,
                            imageAiSize: '1024X1024',
                        }
                    );
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to generate image. The page will reload and try again.',
                        background: '#011225',
                        color: '#fff',
                        timer: 3000,
                        timerProgressBar: true,
                        didClose: () => {
                            window.location.reload();
                        }
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while generating the image. Please try again.',
                    background: '#011225',
                    color: '#fff',
                });
                console.error('Error:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleCancel = () => {
        setName('');
        setOccupation('');
        setPrompt('');
        setImage([]);
        setResultImage(null);
    };

    const handleImageChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const validTypes = ['image/png', 'image/jpeg', 'image/webp'];
        const maxSize = 25 * 1024 * 1024;

        const invalidFiles = selectedFiles.filter(
            (file) => !validTypes.includes(file.type) || file.size > maxSize
        );

        if (invalidFiles.length > 0) {
            Swal.fire({
                icon: 'error',
                text: 'Format not supported. Please use another image.',
                background: '#011225',
                color: '#fff',
            });
            e.target.value = '';
            setImage([]);
            return;
        }

        setImage(selectedFiles);
    };


    const handleDownload = async ({ imageUrl }) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const fileName = imageUrl.split("/").pop();
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // free memory
        } catch (error) {
            console.error("Image download failed:", error);
        }
    };

    const creditTolcalString = AIuser?.credits
        ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
        : "0";
    const creditToLocalString = AIuser?.credits ? parseInt(Math.floor(AIuser?.credits)).toLocaleString() : "0";

    return (
        <Fragment>
            {/* <PageHeading
                title={"TOY STORIES AI"}
                description={
                    "Toy Stories AI transforms your images into charming toy-box-style creations."
                }
                onInfoClick={() => setShowPdfModal(true)}
                infoTooltip="See sample toy story"
            /> */}

            <SamplePdfModal pdfModal={showPdfModal} setPdfModal={setShowPdfModal} title="What you can do?">
                <ContentToy />
            </SamplePdfModal>

            <div className="container pb-2"
                style={{
                    maxWidth: "872px",
                    paddingInline: "12px",
                    marginInline: "auto",
                }}
            >
                <div className="container py-0">
                    {/* <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2">
                        <div className="d-flex ">
                            <CreditsButton />
                        </div>
                    </div> */}
                    <p className="all-page-title all-page-gradient-text text-center my-4">TOY STORIES AI</p>
                    <div className="credits-actions">

                        <button className="credits-button">
                            CREDITS : {creditToLocalString}
                        </button>

                        <button
                            className="buy-credits-button"
                            onClick={() => navigate("/purchase")}
                        >
                            BUY CREDITS
                        </button>

                        <button
                            onClick={() => navigate("/usage")}
                            className="money-exchange-button"
                        >
                            <img src={moneyExchangeIcon} alt="usage" />
                        </button>

                        <button
                            type="button"
                            className="money-exchange-button"
                            onClick={() => {
                                setShowPdfModal(true);
                            }}

                        >
                            <img src={sampleIcon} alt="See sample video" />
                        </button>

                    </div>
                    <p
                        style={{ fontSize: "8px" }}
                        className="text-white text-center mt-2 mb-4 centralize-credits-btn-sm"
                    >
                        10 Credits per image (USD 0.12 based on Credits Package 3)
                    </p>

                    <div className="text-white mt-4">
                        <div className="form-group mb-3">
                            <label className="">Upload Image <span className="text-danger">*</span></label>
                            <input
                                type="file"
                                className="form-control"
                                style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    padding: '10px',
                                    backgroundColor: '#011C34',
                                    color: '#fff',
                                    paddingLeft: '20px',
                                }}
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label>Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    padding: '10px',
                                    backgroundColor: '#011C34',
                                    color: '#fff',
                                }}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label>Profession <span className="text-danger">*</span></label>
                            <div className="position-relative">
                                <textarea
                                    type="text"
                                    className="form-control"
                                    style={{
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        padding: '10px',
                                        backgroundColor: '#011C34',
                                        color: '#fff',
                                        height: "100px"
                                    }}
                                    value={occupation}
                                    onChange={(e) => setOccupation(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* <AiContentAudit checked={auditChecked} onChange={setAuditChecked} /> */}

                        <div className="button-group d-flex justify-content-center gap-4 mt-3" style={{ marginBottom: '40px' }}>
                            <button className="btn btn-primary" onClick={handleGenerate} disabled={loading}>
                                {loading ? 'Processing...' : 'Generate'}
                            </button>
                            <button className="btn btn-secondary ml-2" onClick={handleCancel}>
                                Cancel
                            </button>
                        </div>
                        <div className="animate text-md-center mt-4 text-lg-center text-center mb-5 d-flex justify-content-center force-small-font">
                            Please do not navigate away from the browser.
                            <br /> Doing so will stop the process.
                        </div>
                        <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
                            While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
                        </div>

                        <div className="d-flex justify-content-center mt-3">
                            {loading && (
                                <div className="spinner-border text-light" role="status" style={{ width: '4rem', height: '4rem' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            )}
                        </div>

                        {/* Interesting facts while generating */}
                        {loading && <AiFactsDisplay />}

                        {resultImage && (
                            <div className="mt-3">
                                <p>Generated Image</p>
                                <img src={resultImage} alt="Generated" className="img-fluid" />
                            </div>
                        )}

                        {
                            resultImage && (
                                <div>
                                    <button
                                        className="btn btn-success mt-3"
                                        onClick={() => {
                                            console.log('Image URL:', resultImage);
                                            handleDownload({ imageUrl: resultImage })
                                        }}
                                    >
                                        <i className="fa-solid fa-download"></i>
                                        {' '}
                                        Download
                                    </button>
                                </div>
                            )
                        }


                        <div className="mt-3">
                            <p className='text-warning'>Sample Image</p>
                            <img src={img} alt="Sample" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default TestDigitalToy;
